import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SettingsState {
  shadows: boolean;
  dpr: number;
  audioVolume: number;
  setShadows: (v: boolean) => void;
  setDpr: (v: number) => void;
  setAudioVolume: (v: number) => void;
}

const defaultDpr =
  typeof window !== 'undefined' ? Math.min(window.devicePixelRatio, 2) : 1;

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      shadows: true,
      dpr: defaultDpr,
      audioVolume: 1,
      setShadows: (shadows) => set({ shadows }),
      setDpr: (dpr) => set({ dpr }),
      setAudioVolume: (audioVolume) => set({ audioVolume: Math.max(0, Math.min(1, audioVolume)) }),
    }),
    { name: 'r3f-skeleton:settings' },
  ),
);
